/**
 * mailbox模块接口列表
 */
import $http from '../utils/http'// 导入http中创建的axios实例

const mailbox = {
  //返回分页查询Mailbox列表
  page(params) {
    return $http.post(`${global.API_URL}/sme/monitorMailbox/page`, params);
  },
  //增加Mailbox
  create(params) {
    return $http.post(`${global.API_URL}/sme/monitorMailbox/create`, params);
  },
  //更新Mailbox
  update(params) {
    return $http.post(`${global.API_URL}/sme/monitorMailbox/update`, params);
  },
  //根据Id查询Mailbox
  select(id, params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/monitorMailbox/select`, param);
  },
  //删除Account
  delete(id, params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/monitorMailbox/delete`, param);
  },
  //查询Mailbox下拉框
  queryMailboxByUserName(params) {
    return $http.post(`${global.API_URL}/sme/monitorMailbox/queryMailboxByUserName`, params);
  },
  //返回分页查询SubjectKeyword列表
  pageSubjectKeyword(params){
    return $http.post(`${global.API_URL}/sme/alertRuleMailboxSubjectKeyword/page`, params);
  },
  //增加SubjectKeyword
  createSubjectKeyword(params) {
    return $http.post(`${global.API_URL}/sme/alertRuleMailboxSubjectKeyword/create`, params);
  },
  //删除SubjectKeyword
  deleteSubjectKeyword(id, params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/alertRuleMailboxSubjectKeyword/delete`, param);
  },
  //返回分页查询ToBeProcessed列表
  pageSubjectToBeProcessed(params){
    return $http.post(`${global.API_URL}/sme/alertRuleMailboxSubjectToBeProcessed/page`, params);
  }
}

export default mailbox



// WEBPACK FOOTER //
// ./src/api/mailbox.js